// extracted by mini-css-extract-plugin
export default {"heading":"hw-z","corrected":"iw-z","redirectVerbiageContainer":"jw-z","redirectVerbiageText":"kw-z"};